import { createFormContext } from 'ui/Form';

import { Card } from '../../../api';

export interface UserFormValuesBase {
  terms: boolean;
  name: string;
  month: string;
  year: string;
  zip: string;
  card?: Card;
  isCardValid?: boolean;
  shouldSaveCard?: boolean;
}

// Because it appears their form context is probably utilizing state or something similar, it would appear that it is not as performant as it could be.
//  I believe that the ease of use in this case and the scoping the context to a Card form is probably safe. We can in the future optimize the re-renders on the form.

export const [TokenFormProvider, useUserTokenExFormContext, useTokenExForm] =
  createFormContext<UserFormValuesBase>();
